'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.factory('scheduledOutageService', function() {
  let outagePeriod = false;

  return {
    enableOutagePeriod: function() {
      outagePeriod = true;
    },

    isOutagePeriod: function() {
      return outagePeriod;
    }
  };
});
